// extracted by mini-css-extract-plugin
module.exports =  {"input":"_0d624b9a27--input--LL5G7"};